import type { IndividualSubscription } from "../../../hooks/useTeamsTypes";
import CTARow from "../../CTARow/CTARow";
import { CTARowDivider } from "../../CTARowDivider/CTARowDivider";
import { SubscriptionExpirationText } from "../SubscriptionExpirationText/SubscriptionExpirationText";
import {
  formatExpirationDate,
  getPlanDisplayName,
  getSourceDisplayName,
} from "../subscriptionUtils";

export const PaddleOneTimeSubscriptionInfo: React.FC<{ subscription: IndividualSubscription }> = ({
  subscription,
}) => {
  const planName = getPlanDisplayName(
    subscription.type,
    subscription.subscriptionPeriod,
    subscription.tier
  );
  const expirationDate = new Date(subscription.expirationDate);
  const sourceName = getSourceDisplayName(subscription.type);

  return (
    <>
      <CTARow title="License" text={planName} />
      <CTARowDivider />
      <CTARow
        title={
          <SubscriptionExpirationText
            autoRenews={false}
            subscriptionType={subscription.type}
            expirationDate={expirationDate}
            subscriptionTier={subscription.tier}
          />
        }
        text={formatExpirationDate(subscription.expirationDate)}
      />
      <CTARowDivider />
      <CTARow title="Purchased via" text={sourceName} />
    </>
  );
};
